import React from 'react';
import { dmy, inr, num, pct, qtyUnits, toneClass } from '@/components/po-grn/format';

export const SACell = ({ col, value }) => {
  const neg = typeof value === 'number' && value < 0 ? 'text-red-600 font-semibold' : '';
  if (col.type === 'money') return <span className={neg}>{inr(value)}</span>;
  if (col.type === 'qty') return <span className={neg}>{num(value)}</span>;
  if (col.type === 'pct') return <span className={neg}>{pct(value)}</span>;
  if (col.type === 'date') return dmy(value);
  if (col.type === 'units') return qtyUnits(value);
  if (col.type === 'list') return Array.isArray(value) && value.length ? value.join(', ') : '—';
  if (col.type === 'badge') {
    if (value === null || value === undefined || value === '') return '—';
    return <span className={`inline-block px-2 py-0.5 rounded-full border text-[11px] font-medium whitespace-nowrap ${toneClass(String(value))}`}>{String(value)}</span>;
  }
  return value === null || value === undefined || value === '' ? '—' : String(value);
};
